import { render, staticRenderFns } from "./YtdSalesVsGoals.vue?vue&type=template&id=73666f1b&"
import script from "./YtdSalesVsGoals.vue?vue&type=script&lang=js&"
export * from "./YtdSalesVsGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports